(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!window.PLNBProductCardQuickAdd) {
    window.PLNBProductCardQuickAdd = true;

    document.addEventListener('submit', function(event) {
      var form = event.target.closest('.product-card__form');

      if (!form) {
        return;
      }

      event.preventDefault();
      addProductCardToCart(form);
    });

    document.addEventListener('click', function(event) {
      var card = event.target.closest('.product-card[data-product-card-url]');

      if (!card) {
        return;
      }

      if (event.target.closest('a, button, input, select, textarea, label, .product-card__form')) {
        return;
      }

      window.location.href = card.dataset.productCardUrl;
    });

    function addProductCardToCart(form) {
      var button = form.querySelector('[data-product-card-add]');

      if (!button || button.disabled) {
        return;
      }

      if (form.reportValidity && !form.reportValidity()) {
        return;
      }

      setProductCardButtonLoading(button);

      fetch(getProductCardJsonEndpoint(form.getAttribute('action') || '/cart/add'), {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form)
      })
        .then(parseProductCardResponse)
        .then(function() {
          animateProductCardCartFlyer(button);
          setProductCardButtonSuccess(button);
          return refreshProductCardCartCount();
        })
        .catch(function(error) {
          console.warn(error);
          resetProductCardButton(button);
        });
    }

    function parseProductCardResponse(response) {
      return response.json().catch(function() {
        return {};
      }).then(function(json) {
        if (!response.ok) {
          throw new Error(json.description || json.message || 'Unable to add product to cart.');
        }

        return json;
      });
    }

    function getProductCardJsonEndpoint(path) {
      var url = new URL(path, window.location.origin);

      if (!url.pathname.endsWith('.js')) {
        url.pathname = url.pathname.replace(/\/$/, '') + '.js';
      }

      return url.toString();
    }

    function setProductCardButtonLoading(button) {
      window.clearTimeout(button._productCardResetTimer);
      button.classList.remove('is-added');
      button.classList.add('is-loading');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    function setProductCardButtonSuccess(button) {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.disabled = true;
      button.setAttribute('aria-busy', 'false');

      button._productCardResetTimer = window.setTimeout(function() {
        resetProductCardButton(button);
      }, 2000);
    }

    function resetProductCardButton(button) {
      window.clearTimeout(button._productCardResetTimer);
      button.classList.remove('is-loading', 'is-added');
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }

    function animateProductCardCartFlyer(button) {
      var target = document.querySelector('[data-header-cart]');
      var icon = button.querySelector('.product-card__cart-icon--cart svg');

      if (!target || !icon) {
        return;
      }

      var sourceRect = button.getBoundingClientRect();
      var targetRect = target.getBoundingClientRect();
      var sourceX = sourceRect.left + sourceRect.width / 2;
      var sourceY = sourceRect.top + sourceRect.height / 2;
      var targetX = targetRect.left + targetRect.width / 2;
      var targetY = targetRect.top + targetRect.height / 2;
      var flyer = document.createElement('span');

      flyer.className = 'product-card__cart-flyer';
      flyer.style.left = sourceX + 'px';
      flyer.style.top = sourceY + 'px';
      flyer.appendChild(icon.cloneNode(true));
      document.body.appendChild(flyer);

      if (flyer.animate) {
        flyer.animate([
          {
            left: sourceX + 'px',
            top: sourceY + 'px',
            opacity: 1,
            transform: 'translate(-50%, -50%) scale(1) rotate(0deg)'
          },
          {
            left: sourceX + (targetX - sourceX) * 0.58 + 'px',
            top: sourceY + (targetY - sourceY) * 0.34 - 44 + 'px',
            opacity: 1,
            transform: 'translate(-50%, -50%) scale(0.84) rotate(8deg)'
          },
          {
            left: targetX + 'px',
            top: targetY + 'px',
            opacity: 0.25,
            transform: 'translate(-50%, -50%) scale(0.34) rotate(-10deg)'
          }
        ], {
          duration: 720,
          easing: 'cubic-bezier(0.16, 1, 0.3, 1)'
        }).onfinish = function() {
          flyer.remove();
          pingProductCardCartTarget(target);
        };
      } else {
        window.requestAnimationFrame(function() {
          flyer.style.transition = 'left 720ms cubic-bezier(0.16, 1, 0.3, 1), top 720ms cubic-bezier(0.16, 1, 0.3, 1), opacity 720ms ease, transform 720ms cubic-bezier(0.16, 1, 0.3, 1)';
          flyer.style.left = targetX + 'px';
          flyer.style.top = targetY + 'px';
          flyer.style.opacity = '0.25';
          flyer.style.transform = 'translate(-50%, -50%) scale(0.34) rotate(-10deg)';
        });

        window.setTimeout(function() {
          flyer.remove();
          pingProductCardCartTarget(target);
        }, 760);
      }
    }

    function refreshProductCardCartCount() {
      var target = document.querySelector('[data-header-cart]');

      if (!target) {
        return Promise.resolve();
      }

      return fetch(getProductCardJsonEndpoint(target.getAttribute('href') || '/cart'), {
        headers: {
          Accept: 'application/json'
        }
      })
        .then(parseProductCardResponse)
        .then(function(cart) {
          updateProductCardCartCount(target, cart.item_count || 0);
        })
        .catch(function(error) {
          console.warn(error);
        });
    }

    function updateProductCardCartCount(target, count) {
      var bubble = target.querySelector('[data-cart-count]');

      if (count <= 0) {
        if (bubble) {
          bubble.remove();
        }

        return;
      }

      if (!bubble) {
        bubble = document.createElement('span');
        bubble.dataset.cartCount = '';
        target.appendChild(bubble);
      }

      bubble.textContent = count;
    }

    function pingProductCardCartTarget(target) {
      window.clearTimeout(target._productCardCartPingTimer);
      target.classList.remove('is-cart-ping');
      target.offsetWidth;
      target.classList.add('is-cart-ping');
      target._productCardCartPingTimer = window.setTimeout(function() {
        target.classList.remove('is-cart-ping');
      }, 560);
    }
  }
  } catch(e) { console.error(e); }
})();

})();
